/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/11
 */
import {takeLatest, call, put} from 'redux-saga/effects';
import {
  mapKeysOfOneList,
  filterTwoList,
  combineThrList,
  sortSkuList,
  mapDefaultProps
} from '../reducers/step';
import {
  TO_EVALUATE,
  GET_PRODUCT_OPTIONS,
  TO_ORDER,
  receiveEvaluate,
  receiveProductOptions,
  receiveOrderInfo,
  updateButtonStatus
} from '../actions/step';
import * as stepService from '../services/step';
import history from '../routes/history';
import storage from '../utils/sessionStorage';
import store from '../store';
import { addDialog } from '../actions/app';
import getLoginURI from '../utils/getLoginURI';
const SERVER_ERR = '服务器繁忙';

export function* getProductOptions(action) {
  try {
    storage.clearItem('stepData');
    const data = yield call(stepService.getProductOption, action.pid);
    if (data.success) {
      if (data.data.skus) {
        data.data.skus = sortSkuList(data.data.descList.oneList, data.data.skus);
        data.data.keysOfOneList = mapKeysOfOneList(data.data.descList.oneList);
      }
      data.data.defaultPropsMap = mapDefaultProps(data.data.descList.twoList);
      data.data.descList.twoList = filterTwoList(data.data.descList.twoList);
      data.data.descList.thrList = combineThrList(data.data.descList.thrList, data.data.childDescMap);
      return yield put(receiveProductOptions(data.data));
    } else if (data.code === 401) {
      window.location.replace(getLoginURI(action.pid));
    } else {
      // notify error;
      yield put(addDialog(SERVER_ERR));
    }
  } catch (err) {
    // notify error;
    yield put(addDialog());
    console.log(err);
  }
}

export function* toEvaluate (action) {
  try {
    const selectedStrings = action.payload.selectedStrings;
    delete action.payload.selectedStrings;

    yield put(updateButtonStatus(true));
    const data = yield call(stepService.toEvaluate, action.payload);
    yield put(updateButtonStatus(false));
    if (data.success) {
      yield put(receiveEvaluate(selectedStrings, data.data));
      storage.setItem('stepData', store.getState().step);
      history.push(`/view/appraisal/${action.payload.productId}/step2`);
    } else if (data.code === 401) {
      window.location.replace(getLoginURI(action.payload.productId));
    } else {
      yield put(addDialog(data.msg));
    }
  } catch(err) {
    yield put(updateButtonStatus(false));
    yield put(addDialog());
  }
}

export function* toOrder (action) {
  try {
    yield put(updateButtonStatus(true));
    const data = yield call(stepService.toOrder, action.payload);
    yield put(updateButtonStatus(false));
    if (data.success) {
      storage.clearItem('stepData');
      yield put(receiveOrderInfo(data.data, action.payload));
      history.push(`/view/appraisal/${action.payload.productId}/step3`);
    } else if (data.code === 401) {
      window.location.replace(getLoginURI(action.payload.productId));
    } else if (data.code === 4) {
      yield put(addDialog(data.msg));
    } else {
      yield put(addDialog(SERVER_ERR));
    }
  } catch (err) {
    yield put(updateButtonStatus(false));
    yield put(addDialog());
    console.log(err);
  }
}

export function* watchStep () {
  yield takeLatest(GET_PRODUCT_OPTIONS, getProductOptions);
  yield takeLatest(TO_EVALUATE, toEvaluate);
  yield takeLatest(TO_ORDER, toOrder);
}



// WEBPACK FOOTER //
// ./src/sagas/step.js